(function () {
  /* ---------- Before and after slider ---------- */
  document.querySelectorAll('[data-ws-ba]').forEach(function (fr) {
    var range = fr.querySelector('input');
    var down = false, started = false;
    function set(p) { p = Math.max(0, Math.min(100, p)); fr.style.setProperty('--pos', p + '%'); if (range) range.value = Math.round(p); }
    function fromX(x) { var r = fr.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
    fr.addEventListener('pointerdown', function (e) { down = true; started = true; fromX(e.clientX); if (fr.setPointerCapture) fr.setPointerCapture(e.pointerId); });
    fr.addEventListener('pointermove', function (e) { if (down) fromX(e.clientX); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { fr.addEventListener(t, function () { down = false; }); });
    if (range) {
      range.addEventListener('input', function () { started = true; set(+range.value); });
      fr.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { started = true; set(+range.value + (e.key === 'ArrowLeft' ? -5 : 5)); e.preventDefault(); }
      });
      fr.tabIndex = 0;
    }
    /* a gentle nudge the first time it comes into view, so people know it moves */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return;
        io.disconnect();
        var t0 = null;
        function step(t) {
          if (started) return;
          if (!t0) t0 = t;
          var k = (t - t0) / 1600;
          if (k >= 1) { set(50); return; }
          set(50 + Math.sin(k * Math.PI * 2) * 18);
          requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      }, { threshold: 0.6 });
      io.observe(fr);
    }
  });
})();
